import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

const STORAGE_KEY = "cookie_consent_accepted";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie-Hinweis"
      className="fixed bottom-0 left-0 right-0 z-50 px-4 py-4 bg-[var(--vortex-surface)] border-t-2 border-[var(--vortex-border)] shadow-lg"
    >
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 min-w-0">
        <p className="text-sm text-[var(--vortex-text-secondary)] flex-1 min-w-0 break-words">
          Wir verwenden Cookies und ähnliche Technologien, um die Website zu
          betreiben und Ihre Nutzererfahrung zu verbessern. Durch Klicken auf
          „Akzeptieren“ stimmen Sie der Verwendung zu. Weitere Informationen
          finden Sie in unserer{" "}
          <Link
            to="/datenschutz"
            className="text-[var(--vortex-accent-primary)] hover:underline font-medium"
          >
            Datenschutzerklärung
          </Link>{" "}
          und unserer{" "}
          <Link
            to="/cookies"
            className="text-[var(--vortex-accent-primary)] hover:underline font-medium"
          >
            Cookie-Richtlinie
          </Link>
          .
        </p>
        <Button
          onClick={accept}
          className="btn-primary flex-shrink-0 w-full sm:w-auto"
        >
          Akzeptieren
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
